import React from 'react'
import { StatusBoxStyled } from '../status-box'
import { TransportMode, TransportModeLabels } from '../../../types/transport'

type TransportModeBadgeProps = {
  mode: TransportMode | undefined | null
  style?: React.CSSProperties
}

/**
 * Badge component for displaying transport mode
 * Shows colored badge for LTL (blue) and TL (purple)
 * Returns null for parcel mode (default, no badge needed)
 */
export const TransportModeBadge = ({ mode, style }: TransportModeBadgeProps) => {
  // Don't show badge for parcel (default mode)
  if (!mode || mode === 'parcel') {
    return null
  }

  const getColor = (mode: TransportMode): string => {
    switch (mode) {
      case 'ltl':
        return 'blue'
      case 'tl':
        return 'purple'
      default:
        return 'silver'
    }
  }

  return (
    <StatusBoxStyled className={`${getColor(mode)} bold`} style={{ minWidth: 75, margin: '0.5em auto', ...style }}>
      {TransportModeLabels[mode]}
    </StatusBoxStyled>
  )
}

export default TransportModeBadge
